import * as React from 'react';
import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';
import { NavLink, withRouter, RouteProps } from 'react-router-dom';
import { translate } from 'react-i18next';
import { State } from 'reducers';
import { TranslateProps } from 'util/i18n';
import { getPermissions } from 'selectors/shellSelectors';

export const toUrl = (...words: string[]): string =>
    words.reduce((url, word) => `${url}/${word.toLowerCase().replace(' ', '-')}`, '/Client')
;

const RawNavigation = ({ t, location }: TranslateProps & RouteProps) => {
    const labels = {
        monitoring: t('6.1241.0.88'),
        reports: t('2730'),
        new: t('190'),
    };
    const urls = {
        monitoring: toUrl('monitoring'),
        reports: toUrl('reports'),
        reportsNew: toUrl('reports', 'new'),
    };

    return (
        <nav>
            <ul>
                <li>
                    <NavLink
                        id="monitoring-link"
                        activeClassName="selected"
                        to={ urls.monitoring }
                        isActive={ () => location!.pathname === urls.monitoring }
                    >
                        { labels.monitoring }
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        id="reports-link"
                        activeClassName="selected"
                        to={ urls.reports }
                        isActive={ () => location!.pathname === urls.reports }
                    >
                        { labels.reports }
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
};

const mapStateToProps = (state: State) => ({
    location: state.router.location,
    canExecuteReports: getPermissions(state).executeReport,
});

export const Navigation = compose<TranslateProps & RouteProps, {}>(
    translate(),
    withRouter,
    connect(mapStateToProps),
    // Can hide navigation entirely if user can't execute reports... Just keep them in the Monitoring section
    branch(({ canExecuteReports }) => !canExecuteReports, renderNothing),
)(RawNavigation);



// WEBPACK FOOTER //
// ./src/ui/main/header/Navigation.tsx